import {
  FETCH_FILTER_OPTIONS_REQUEST,
  FETCH_FILTER_OPTIONS_SUCCESS,
  FETCH_FILTER_OPTIONS_FAILURE,
} from '../actions/actionTypes';
import { FilterOptionsAction, FilterOptionItem } from '../actions/filterOptionsActions';

export interface FilterOptionsState {
  accountManagers: FilterOptionItem[];
  zones: FilterOptionItem[];
  countries: FilterOptionItem[];
  languageProficiencies: string[];
  sources: string[];
  utmMediums: string[];
  utmTerms: string[];
  utmContents: FilterOptionItem[];
  roles: string[];
  rejectedByNames: string[];
  tags: FilterOptionItem[];
  skills: FilterOptionItem[];
  metadataRaw: Record<string, any>;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

const initialState: FilterOptionsState = {
  accountManagers: [],
  zones: [],
  countries: [],
  languageProficiencies: [],
  sources: [],
  utmMediums: [],
  utmTerms: [],
  utmContents: [],
  roles: [],
  rejectedByNames: [],
  tags: [],
  skills: [],
  metadataRaw: {},
  loading: false,
  loaded: false,
  error: null,
};

export default function filterOptionsReducer(
  state: FilterOptionsState = initialState,
  action: FilterOptionsAction,
): FilterOptionsState {
  switch (action.type) {
    case FETCH_FILTER_OPTIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        accountManagers: action.payload.accountManagers,
        zones: action.payload.zones,
        countries: action.payload.countries,
        languageProficiencies: action.payload.languageProficiencies,
        sources: action.payload.sources,
        utmMediums: action.payload.utmMediums,
        utmTerms: action.payload.utmTerms,
        utmContents: action.payload.utmContents,
        roles: action.payload.roles,
        rejectedByNames: action.payload.rejectedByNames,
        tags: action.payload.tags,
        skills: action.payload.skills,
        metadataRaw: action.payload.metadataRaw,
      };

    case FETCH_FILTER_OPTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
